<div class="p-3 w-100" style="white-space: pre-wrap">{{"COLORSCODE.MAIN_DESCRIPTION" |translate}}</div>

<div class="table-responsive w-100">
  <table class="table table-responsive table-striped table-borderless mb-0 w-100 d-block d-sm-table">
    <thead>
      <tr>
        <th style="width: 33.3%">{{"COLORSCODE.PRIORITY_COLOR" |translate}}</th>
        <th style="width: 33.3%">{{"COLORSCODE.TURBINE_COLORCODE" |translate}}</th>
        <th style="width: 33.3%">{{"COLORSCODE.SHORT_DESCRIPTION" |translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (colour of colours; track colour) {
        <tr>
          <td class="text-primary" style="width: 33.3%">
            {{ colour.priority }}
          </td>
          <td class="text-primary" style="width: 33.3%">
            <i class="fas fa-circle mr-1" [ngStyle]="{'color': colour.priority | colorStatusCode: 'color'}" [ngClass]="{ 'outline-circle': colour.priority === 5 }" ></i>
            {{ colour.priority | colorStatusCode: 'colorName' |translate }}
          </td>
          <td class="text-primary" style="width: 33.3%">
            {{ colour.priority | colorStatusCode: 'description' |translate}}
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>